// removed by extract-text-webpack-plugin
module.exports = {"fadeOutSection":"fadeOutSection__1-UZg","isHidden":"isHidden__19YHb"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/fadeOutSection/style.css
// module id = 78RU
// module chunks = 444